import React from "react"
import styled from "styled-components"

const SimpleFormInput = ({
  handleOnChange,
  value,
  placeholder,
  label,
  btnLabel,
  type,
  list,
  disabled,
  defValue,
  id,
  name
}) => {
    // const [isDisabled, setIsDisabled] = useState(true);

  return (
    <InputWrap>
      <label htmlFor="inputfbox">{label}</label>
      <InputField
        name={name}
        id={id}
        defaultValue={defValue}
        disabled={disabled}
        type={type}
        list={list}
        placeholder={placeholder}
        value={value}
        onChange={handleOnChange}
      />
      {/* <InputActionBtn onClick={() => setIsDisabled((prev) => !prev)}>{isDisabled? btnLabel: "Done"}</InputActionBtn> */}
    </InputWrap>
  )
}

export default SimpleFormInput

const InputWrap = styled.div`
  display: flex;
  width: 100%;
  height: 3rem;
  align-items: center;
  background: ${({ theme }) => theme.background};
  border-radius: 5px;
  margin: 5px 0px;

  label {
    padding: 0rem 1rem;
    color: ${({ theme }) => theme.secondryText};
    font-size: 0.8rem;
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    min-width: 10%;
    max-width: 15%;
    width: 10%;
    margin-right: 0.5rem;
    border-right: 1.5px solid  ${({ theme }) => theme.accent};
  }
`
const InputField = styled.input`
  width: 85%;
  height: 2.5rem;
  background: none;
  border: none;
  color: ${({ theme }) => theme.secondryText};

  :focus {
    outline: none;
  }
`
const InputActionBtn = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.secondryText};
  font-size: 0.8rem;
  font-family: Montserrat;
  font-style: normal;
  text-align: right;
  font-weight: normal;
  display: block;
  width: 10%;
  cursor: pointer;
`
